import { render, staticRenderFns } from "./CardFeaturedImage.vue?vue&type=template&id=1a028bcd&scoped=true"
import script from "./CardFeaturedImage.vue?vue&type=script&lang=js"
export * from "./CardFeaturedImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a028bcd",
  null
  
)

export default component.exports